webpackJsonp([1],{

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(316)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(258),
  /* template */
  __webpack_require__(423),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Browse__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Browse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Browse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Frame__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Frame___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Frame__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/frame/:url',
    name: 'Frame',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Frame___default.a,
    props: true
  }, {
    path: '/browse/*',
    name: 'Browse',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Browse___default.a
  }, {
    path: '/browse',
    name: 'Browse-default',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Browse___default.a,
    props: function props(route) {
      return { url: route.query.url };
    }
  }, {
    path: '*',
    redirect: '/browse'
  }]
}));

/***/ }),

/***/ 230:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(250);



var _this = this;






__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* default */]);

var store = {
	state: {
		bases: {
			fileApi: "https://assetlocker-api.asset-locker.dev-a.hpgsb.net/api",
			rasterApi: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].rasterApi
		},
		items: [],
		item: {},
		path: "/"
	},
	getters: {
		bases: function bases(state) {
			return state.bases;
		},
		path: function path(state) {
			return state.path;
		},
		items: function items(state) {
			return state.items;
		},
		item: function item(state) {
			return state.item;
		},
		folders: function folders(state) {
			return state.items.filter(function (item) {
				return item.type === 'folder';
			});
		},
		files: function files(state) {
			return state.items.filter(function (item) {
				return item.type === 'file';
			});
		}
	},
	mutations: {
		'SET_PATH': function SET_PATH(state, path) {
			return state.path = path;
		},
		'SET_ITEMS': function SET_ITEMS(state, docs) {
			return state.items = docs;
		},
		'SET_ITEM': function SET_ITEM(state, doc) {
			return state.item = doc;
		}
	},
	actions: {
		setPath: function setPath(_ref, path) {
			var commit = _ref.commit,
			    state = _ref.state,
			    dispatch = _ref.dispatch;

			commit('SET_PATH', path);
			dispatch("loadItems", path);
		},
		createPath: function () {
			var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref3, path) {
				var commit = _ref3.commit,
				    state = _ref3.state;
				var url, results;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								url = state.bases.fileApi + '/paths';
								_context.next = 3;
								return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post(url, path);

							case 3:
								results = _context.sent;
								return _context.abrupt('return', results);

							case 5:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}));

			return function createPath(_x, _x2) {
				return _ref2.apply(this, arguments);
			};
		}(),
		loadItems: function loadItems(_ref4, path) {
			var commit = _ref4.commit,
			    state = _ref4.state;

			var url = '' + state.bases.fileApi + path;
			__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.get(url).then(function (results) {
				commit('SET_ITEMS', results.body.content);
				commit('SET_ITEM', results.body.data);
			});
		}
	}
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* default */].Store(store));

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(313)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(420),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var config = void 0;

switch (location.hostname) {
	case 'media.oneflowcloud.com':
	case 'media-ui-s3cf.oneflowcloud.com':
	case 'pdf-viewer.oneflowcloud.com':
	case 'pdf-viewer-s3cf.oneflowcloud.com':
		config = {
			rasterApi: 'https://media-api.oneflowcloud.com'
		};
		break;
	case 'media-ui.stage-a.hpgsb.net':
		config = {
			rasterApi: 'https://media-api.media.stage-a.hpgsb.net'
		};
		break;
	case 'media-ui.dev-a.hpgsb.net':
	case 'localhost':
		config = {
			rasterApi: 'https://media-api.media.dev-a.hpgsb.net'
		};
		break;
}

/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),

/***/ 251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_store__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resource__ = __webpack_require__(232);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
	el: '#app',
	store: __WEBPACK_IMPORTED_MODULE_3__vuex_store__["a" /* default */],
	router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
	template: '<App/>',
	components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      version: __webpack_require__.i({"NODE_ENV":"production"}).VERSION
    };
  }
});

/***/ }),

/***/ 253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_trim__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Upload_vue__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Upload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Upload_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FileList_vue__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FileList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__FileList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Toolbar_vue__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Toolbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Toolbar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Pdf_vue__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Pdf_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__Pdf_vue__);














/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['url'],
	components: {
		Upload: __WEBPACK_IMPORTED_MODULE_8__Upload_vue___default.a,
		FileList: __WEBPACK_IMPORTED_MODULE_9__FileList_vue___default.a,
		Pdf: __WEBPACK_IMPORTED_MODULE_11__Pdf_vue___default.a,
		Toolbar: __WEBPACK_IMPORTED_MODULE_10__Toolbar_vue___default.a
	},
	created: function created() {
		this.setPath(this.$router.currentRoute.path);
	},
	data: function data() {
		return {
			showInks: false,
			showRulers: true,
			showOverview: true,
			showOverprint: false,
			page: 1,
			zoom: 5,
			zoom100: 5,
			unit: "mm",
			selectedUrl: "",
			newFolderName: "",
			showModal: false,
			showBoxes: false,
			selectedFile: null,
			isMobileFileBrowserVisible: false
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(['item', 'items', 'folders', 'files', 'bases']), {
		breadcrumbPath: function breadcrumbPath() {
			var path = __WEBPACK_IMPORTED_MODULE_7_lodash_trim___default()(this.$route.path || '', '/');
			return path.split('/');
		},
		zoomLevel: function zoomLevel() {
			return Math.pow(2, this.zoom - this.zoom100) * 100;
		}
	}),
	methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['createPath', 'setPath', 'setView']), {
		refresh: function refresh() {
			this.setPath(this.$router.currentRoute.path);
		},
		goUp: function goUp() {
			var path = this.$router.currentRoute.path;
			var parts = path.split("/");
			var newParts = parts.pop();
			var newPath = parts.join("/");
			this.$router.push(newPath);
			this.refresh();
		},
		goToFolder: function goToFolder(e, folder) {
			e.preventDefault();
			var parts = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(folder.path));
			parts.shift();
			this.$router.push('/browse/' + parts.join("/"));
			this.refresh();
			return false;
		},
		selectFile: function selectFile(file) {
			var _this = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								console.log(file);
								file.selected = !file.selected;
								if (_this.selectedFile) _this.selectedFile = null;else _this.selectedFile = file;

							case 3:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		isSelected: function isSelected(file) {
			return file.selected;
		},
		handleCreateFolder: function handleCreateFolder() {
			$('.folder-modal').modal('show');
		},
		handleCloseFolderModal: function handleCloseFolderModal() {
			$('.folder-modal').modal('hide');
			this.newFolderName = "";
		},
		createFolder: function createFolder() {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								_context2.next = 2;
								return _this2.createPath({
									path: {
										name: _this2.newFolderName,
										type: "folder"
									},
									parentId: _this2.item._key
								});

							case 2:
								_this2.refresh();
								$('.folder-modal').modal('hide');

							case 4:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this2);
			}))();
		},
		handleCreateFile: function handleCreateFile(name, url) {
			var _this3 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
				var self;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								self = _this3;
								_context3.next = 3;
								return self.createPath({
									path: {
										name: name,
										type: "file"
									},
									fileUrl: url,
									parentId: self.item._key
								});

							case 3:
								self.refresh();

							case 4:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, _this3);
			}))();
		},
		uploadComplete: function uploadComplete(data) {
			var _this4 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								_context4.next = 2;
								return _this4.handleCreateFile(data.file.name, data.uploadUrl);

							case 2:
								_this4.showModal = false;

							case 3:
							case 'end':
								return _context4.stop();
						}
					}
				}, _callee4, _this4);
			}))();
		},
		showUploadModal: function showUploadModal() {
			var _this5 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
					while (1) {
						switch (_context5.prev = _context5.next) {
							case 0:
								_this5.showModal = true;

							case 1:
							case 'end':
								return _context5.stop();
						}
					}
				}, _callee5, _this5);
			}))();
		},
		handleMetadataClick: function handleMetadataClick(file) {
			var _this6 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
				var fileData;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
					while (1) {
						switch (_context6.prev = _context6.next) {
							case 0:
								_this6.selectedFile = file;
								_context6.next = 3;
								return _this6.$http.get(_this6.bases.fileApi + '/files/getdownloadurl/' + file.file._key);

							case 3:
								fileData = _context6.sent;

								_this6.selectedUrl = fileData.body.url;
								_this6.isMobileFileBrowserVisible = false;

							case 6:
							case 'end':
								return _context6.stop();
						}
					}
				}, _callee6, _this6);
			}))();
		},
		handleDelete: function handleDelete(path) {
			var _this7 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
				var deleteUrl, results;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
					while (1) {
						switch (_context7.prev = _context7.next) {
							case 0:
								deleteUrl = _this7.bases.fileApi + '/paths/' + path._key;
								_context7.next = 3;
								return _this7.$http.delete(deleteUrl);

							case 3:
								results = _context7.sent;

								_this7.refresh();

							case 5:
							case 'end':
								return _context7.stop();
						}
					}
				}, _callee7, _this7);
			}))();
		},
		disabledUp: function disabledUp() {
			return this.$router.currentRoute.path.split("/").length < 3;
		},
		formatDate: function formatDate(date) {
			return __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).format("DD/M/YYYY h:mm:ss");
		},
		handleMobilePathClick: function handleMobilePathClick() {
			this.isMobileFileBrowserVisible = !this.isMobileFileBrowserVisible;
		},
		nextPage: function nextPage() {
			this.page++;
		},
		prevPage: function prevPage() {
			if (this.page < 2) return;
			this.page--;
		},
		goToPage: function goToPage(page) {
			this.page = parseInt(page);
		},
		changePage: function changePage(page) {
			this.page = parseInt(page);
		},
		zoomIn: function zoomIn() {
			if (this.zoom < 12) this.zoom = Math.floor(this.zoom + 1);
		},
		zoomOut: function zoomOut() {
			if (this.zoom > 1) this.zoom = Math.ceil(this.zoom - 1);
		},
		fitTo: function fitTo(target) {
			this.$refs.pdf.fitTo(target);
		},
		zoomEnd: function zoomEnd(zoom) {
			this.zoom = zoom;
		},
		setUnits: function setUnits(unit) {
			this.unit = unit;
		},
		_showInks: function _showInks() {
			this.showInks = !this.showInks;
		},
		_showOverview: function _showOverview() {
			this.showOverview = !this.showOverview;
		},
		_showOverprint: function _showOverprint() {
			this.showOverprint = !this.showOverprint;
		},
		_toggleBoxes: function _toggleBoxes() {
			this.showBoxes = !this.showBoxes;
		},
		_toggleRulers: function _toggleRulers() {
			this.showRulers = !this.showRulers;
		}
	}),
	watch: {
		'$route': function $route() {
			this.refresh();
		}
	}
});

/***/ }),

/***/ 254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_leaflet__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(21);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['folders', 'files', 'goToFolder', 'handleMetadataClick', 'handleDelete']
});

/***/ }),

/***/ 255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Pdf_vue__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Pdf_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Pdf_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_get__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty__);









/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['url'],
	data: function data() {
		return {
			spineAdjust: {},
			page: 1,
			zoom: 5,
			zoom100: 5,
			preferences: {
				showOverview: true,
				showOverprint: false,
				showRulers: true,
				showInks: false,
				showBoxes: true,
				unit: "mm",
				selectedInks: [],
				selectedBoxes: []
			},
			parentWindow: null,
			parentUrl: null
		};
	},

	components: {
		Pdf: __WEBPACK_IMPORTED_MODULE_3__Pdf_vue___default.a
	},
	created: function created() {
		var _this = this;

		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							_context.next = 2;
							return _this.bindMessaging();

						case 2:
							_this.sendPreferences();

						case 3:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, _this);
		}))();
	},

	methods: {
		bindMessaging: function bindMessaging() {
			var _this2 = this;

			window.addEventListener("message", function (_ref) {
				var data = _ref.data;
				var command = data.command,
				    args = data.args;

				if (command === "zoomIn" && _this2.zoom < 12) _this2.zoom = Math.floor(_this2.zoom + 1);
				if (command === "zoomOut" && _this2.zoom > 1) _this2.zoom = Math.ceil(_this2.zoom - 1);
				if (command === "actualSize") _this2.zoom = _this2.zoom100;
				if (command === "setSpines") _this2.setSpines(args);
				if (command === "fitToPage") _this2.fitTo('page');
				if (command === "fitToWidth") _this2.fitTo('width');
				if (command === "nextPage") _this2.nextPage();
				if (command === "prevPage") _this2.prevPage();
				if (command === "changePage") _this2.changePage(args);
				if (command === 'setPreferences') {
					var key = args.key,
					    value = args.value;

					_this2.preferences[key] = value;
				}
				if (command === 'setPreferencesUnit') {
					_this2.preferences.unit = args;
				}
				_this2.sendPreferences();
			}, false);

			this.parentUrl = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
				window.addEventListener("message", function (_ref2) {
					var data = _ref2.data;
					var command = data.command,
					    args = data.args;

					if (command === "setParentUrl") {
						resolve(args);
						_this2.postMessageToParent('ready');
					}
				});
			});

			return this.parentUrl;
		},
		sendPreferences: function sendPreferences() {
			this.postMessageToParent('setPreferences', this.preferences);
		},
		nextPage: function nextPage() {
			this.page++;
			this.postMessageToParent('pageChanged', this.page);
		},
		prevPage: function prevPage() {
			if (this.page < 2) return;
			this.page--;
			this.postMessageToParent('pageChanged', this.page);
		},
		goToPage: function goToPage(page) {
			this.page = parseInt(page);
			this.postMessageToParent('pageChanged', this.page);
		},
		changePage: function changePage(page) {
			this.page = parseInt(page);
			this.postMessageToParent('pageChanged', this.page);
		},
		handleFileLoaded: function handleFileLoaded(view) {
			if (__WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty___default()(this.preferences.selectedInks)) {
				this.preferences.selectedInks = view.data.page.inks.map(function (ink) {
					return ink.colorantName;
				}) || [];
			}
			if (__WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty___default()(this.preferences.selectedBoxes)) {
				this.preferences.selectedBoxes = view.data.page.boxes.map(function (box) {
					return box.type;
				}) || [];
			}
			this.postMessageToParent('viewInfo', view);
			this.sendPreferences();
		},
		postMessageToParent: function postMessageToParent(command, args) {
			var _this3 = this;

			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
				var parentUrl;
				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								_context2.next = 2;
								return _this3.parentUrl;

							case 2:
								parentUrl = _context2.sent;

								window.parent.postMessage({ command: command, args: args }, parentUrl);

							case 4:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this3);
			}))();
		},
		zoomEnd: function zoomEnd(zoom) {
			this.zoom = zoom;
		},
		setSpines: function setSpines(spineAdjust) {
			this.spineAdjust = spineAdjust;
		},
		fitTo: function fitTo(target) {
			this.$refs.pdf.fitTo(target);
		}
	}
});

/***/ }),

/***/ 256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);



/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['inks'],
	methods: {
		reload: function reload() {
			console.log(this.inks);


			var selectedInks = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.inks, function (ink) {
				return ink.selected;
			});

			this.$emit("reload-inks", selectedInks);
		}
	}
});

/***/ }),

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery_ui_ui_widgets_draggable__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery_ui_ui_widgets_draggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery_ui_ui_widgets_draggable__);




/* harmony default export */ __webpack_exports__["default"] = ({
	components: {},
	data: function data() {
		return {
			$element: null,
			$currentViewport: null
		};
	},

	props: ['view', 'generateUrl', 'onDragStop', 'viewport'],
	created: function created() {
		var _this = this;

		this.$nextTick(function () {
			return _this.initUI();
		});
	},

	computed: {
		imgUrl: function imgUrl() {
			return this.generateUrl(this.view.page, { size: 150 });
		}
	},
	methods: {
		currentViewportStyle: function currentViewportStyle() {
			var width = this.viewport.width < 1 ? this.viewport.width : 1;
			var height = this.viewport.height < 1 ? this.viewport.height : 1;
			var left = this.viewport.left > 1 ? 1 : this.viewport.left;
			var top = this.viewport.top > 1 ? 1 : this.viewport.top;
			return {
				width: width * 100 + '%',
				height: height * 100 + '%',
				top: top * 100 + '%',
				left: left * 100 + '%'
			};
		},
		initUI: function initUI() {
			this.$element = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el);
			this.$currentViewport = this.$element.find('.OverviewMap-currentViewport');
			this.$currentViewport.draggable({
				containment: this.$element,
				stop: this.handleDragStop
			});
		},
		handleDragStop: function handleDragStop(e) {
			var _ref = [this.$element.width(), this.$element.height()],
			    width = _ref[0],
			    height = _ref[1];
			var _ref2 = [this.$currentViewport.outerWidth(), this.$currentViewport.outerHeight()],
			    viewportWidth = _ref2[0],
			    viewportHeight = _ref2[1];

			var _$currentViewport$pos = this.$currentViewport.position(),
			    top = _$currentViewport$pos.top,
			    left = _$currentViewport$pos.left;

			var percentSize = {
				top: (top + viewportHeight / 2) * 100 / height,
				left: (left + viewportWidth / 2) * 100 / width
			};
			console.log(percentSize);

			this.onDragStop(percentSize);
		}
	}
});

/***/ }),

/***/ 258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_log2__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_log2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_log2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_leaflet__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_leaflet_loading__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_leaflet_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_leaflet_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_leaflet_loading_src_Control_Loading_css__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_leaflet_loading_src_Control_Loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_leaflet_loading_src_Control_Loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Ruler__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Ruler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Ruler__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PointMeasure__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ThumbnailsSlider_vue__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ThumbnailsSlider_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ThumbnailsSlider_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__OverviewMap_vue__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__OverviewMap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__OverviewMap_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Inks_vue__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Inks_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__Inks_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_Tile_2x_png__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_Tile_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_Tile_2x_png__);


















/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['spineAdjust', 'url', 'zoom', 'page', 'unit', 'showOverview', 'showOverprint', 'showInks', 'showRulers', 'showBoxes', 'changePage', 'onFileLoaded', 'selectedInks', 'selectedBoxes', 'zoomEnd'],
	components: {
		Ruler: __WEBPACK_IMPORTED_MODULE_9__Ruler___default.a,
		OverviewMap: __WEBPACK_IMPORTED_MODULE_12__OverviewMap_vue___default.a,
		ThumbnailsSlider: __WEBPACK_IMPORTED_MODULE_11__ThumbnailsSlider_vue___default.a,
		Inks: __WEBPACK_IMPORTED_MODULE_13__Inks_vue___default.a
	},
	data: function data() {
		return {
			rasterMask: '/api/media/tile/{z}/{x}/{y}?width={width}&height={height}&ratio={ratio}&page={page}&' + 'url={sourceUrl}&overprint={overprint}&size={size}',
			separationMask: '/api/media/tile/separated/{z}/{x}/{y}?width={width}&height={height}&ratio={ratio}&' + 'page={page}&inks={inks}&url={sourceUrl}&overprint={overprint}&' + 'size={size}',
			map: null,
			tileSize: 256,
			ratio: 1,
			zoom100: 5,
			pointMMRatio: 0.3527777778,
			pointsPerInch: 72,
			layers: [],
			inks: [],
			boxes: {},
			mapOptions: {
				crs: __WEBPACK_IMPORTED_MODULE_5_leaflet___default.a.CRS.Simple,
				minZoom: 1,
				maxZoom: 12,
				doubleClickZoom: false,
				zoomControl: false,
				zoomSnap: 0.2,
				maxBoundsViscosity: 0.9,
				inertia: false,
				zoomAnimation: false
			},

			view: {},
			screen: {
				dpi: 96,
				dpmm: 72
			},
			panel: {
				width: 0,
				height: 0,
				centre: {
					x: 0,
					y: 0
				}
			},
			doc: {
				pageCount: 0,
				width: new __WEBPACK_IMPORTED_MODULE_10__PointMeasure__["a" /* default */](0, 96),
				height: new __WEBPACK_IMPORTED_MODULE_10__PointMeasure__["a" /* default */](0, 96),
				topLeft: {
					x: 0,
					y: 0
				}
			},
			offset: {
				base: { position: "relative" },
				h: { left: "0" },
				v: { top: "0" }
			},
			viewport: {
				width: 1,
				height: 1
			}
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* mapGetters */])(['bases']), {
		zoomLevel: function zoomLevel() {
			return Math.pow(2, this.zoom - this.zoom100) * 100;
		}
	}),
	mounted: function mounted() {
		var _this = this;

		this.patchLeaflet();
		this.map = __WEBPACK_IMPORTED_MODULE_5_leaflet___default.a.map('viewer', this.mapOptions).setView([0, 0], this.zoom);
		this.map.on("zoomend", function (event) {
			return _this.performZoom();
		});
		this.map.on("move", function (event) {
			return _this.moveMap();
		});
		this.map.on("resize", function (event) {
			return _this.getMapDimensions();
		});
		this.map.on("load", function (event) {
			return _this.getMapDimensions();
		});
		this.map.on("viewreset", function (event) {
			return _this.getMapDimensions();
		});

		this.loadingTimeout = 8000;
		var loadingControl = __WEBPACK_IMPORTED_MODULE_5_leaflet___default.a.Control.loading({
			separate: true,
			delayIndicator: this.loadingTimeout
		});
		this.map.addControl(loadingControl);

		if (this.url) {
			this.map.setZoom(this.zoom100);

			this.loadFile();
		}

		this.init();
	},

	methods: {
		patchLeaflet: function patchLeaflet() {
			var originalInitTile = __WEBPACK_IMPORTED_MODULE_5_leaflet___default.a.GridLayer.prototype._initTile;
			if (originalInitTile.isPatched) return;
			__WEBPACK_IMPORTED_MODULE_5_leaflet___default.a.GridLayer.include({
				_initTile: function _initTile(tile) {
					originalInitTile.call(this, tile);
					var tileSize = this.getTileSize();
					tile.style.width = tileSize.x + 1 + 'px';
					tile.style.height = tileSize.y + 1 + 'px';
				}
			});
			__WEBPACK_IMPORTED_MODULE_5_leaflet___default.a.GridLayer.prototype._initTile.isPatched = true;
		},
		init: function init() {
			this.getMapDimensions();
			this.screen.dpi = $("#inch1").width();
			this.screen.ppmm = this.screen.dpi / 25.4;
			this.clearLayers();
		},
		moveMap: function moveMap() {
			this.calcCentre();
			this.calcOffset();
			this.calcViewport();
		},
		calcOffset: function calcOffset() {
			this.offset.h.left = this.doc.topLeft.x + 'px';
			this.offset.v.top = this.doc.topLeft.y + 'px';
		},
		calcCentre: function calcCentre() {
			var centre = this.map.getCenter();
			var dx = centre.lng * Math.pow(2, this.zoom);
			var dy = centre.lat * Math.pow(2, this.zoom);
			var halfDocX = this.doc.width.toPixel() / 2 / Math.pow(2, 5 - this.zoom);
			var halfDocY = this.doc.height.toPixel() / 2 / Math.pow(2, 5 - this.zoom);
			this.doc.topLeft = {
				x: this.panel.centre.x - dx - halfDocX,
				y: this.panel.centre.y + dy - halfDocY
			};
		},
		calcViewport: function calcViewport() {
			var width = this.panel.width / (this.doc.width.toPixel() / Math.pow(2, 5 - this.zoom));
			var height = this.panel.height / (this.doc.height.toPixel() / Math.pow(2, 5 - this.zoom));
			var top = -this.doc.topLeft.y / (this.doc.height.toPixel() / Math.pow(2, 5 - this.zoom));
			var left = -this.doc.topLeft.x / (this.doc.width.toPixel() / Math.pow(2, 5 - this.zoom));
			this.viewport = {
				width: width,
				height: height,
				top: top < 0 ? 0 : top,
				left: left < 0 ? 0 : left
			};
		},
		getMapDimensions: function getMapDimensions() {
			var size = this.map.getSize();
			this.panel.width = size.x;
			this.panel.height = size.y;
			this.panel.centre.x = this.panel.width / 2;
			this.panel.centre.y = this.panel.height / 2;
			this.calcCentre();
		},
		setPageValues: function setPageValues() {
			this.doc.width = new __WEBPACK_IMPORTED_MODULE_10__PointMeasure__["a" /* default */](_.get(this, "view.data.page.width"), this.screen.dpi);
			this.doc.height = new __WEBPACK_IMPORTED_MODULE_10__PointMeasure__["a" /* default */](_.get(this, "view.data.page.height"), this.screen.dpi);
			this.ratio = this.doc.width.toPixel() / this.doc.width.points;
			this.doc.pageCount = _.get(this, "view.data.file.pageCount");
		},
		loadFile: function loadFile() {
			var _this2 = this;

			var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
			    _ref$skipMetadata = _ref.skipMetadata,
			    skipMetadata = _ref$skipMetadata === undefined ? false : _ref$skipMetadata;

			return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
				return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_this2.loading = true;
								setTimeout(function () {
									if (_this2.loading) {
										_this2.map.fire('dataloading');
									}
								}, _this2.loadingTimeout);

								if (skipMetadata) {
									_context.next = 5;
									break;
								}

								_context.next = 5;
								return _this2.fetchMetaData();

							case 5:
								_this2.init();
								_this2.drawPage();

							case 7:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this2);
			}))();
		},
		fetchMetaData: function fetchMetaData() {
			var _this3 = this;

			return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
				var metadataUrl, metadata;
				return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								metadataUrl = _this3.bases.rasterApi + '/api/media/metadata?page=' + _this3.page + '&url=' + encodeURIComponent(_this3.url);
								_context2.next = 3;
								return _this3.$http.get(metadataUrl);

							case 3:
								metadata = _context2.sent;

								console.log("token", metadata.body.token);
								_this3.view = {
									page: _this3.page,
									url: metadata.body.token || _this3.url,
									data: metadata.body
								};
								_this3.inks = _.get(_this3, 'view.data.page.inks', []);
								_this3.setBoxColours();

								_this3.onFileLoaded && _this3.onFileLoaded(_this3.view);

							case 9:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this3);
			}))();
		},
		setBoxColours: function setBoxColours() {
			var colours = {
				MediaBox: '#00ff00',
				TrimBox: '#ff0000',
				BleedBox: '#5E35B1',
				CropBox: '#0000ff',
				ArtBox: '#ffff00'
			};
			_.each(this.view.data.page.boxes, function (box) {
				return box.colour = colours[box.type];
			});
		},
		setMaxBounds: function setMaxBounds() {
			var w = this.doc.width.toPixel() / Math.pow(2, this.zoom100);
			var h = this.doc.height.toPixel() / Math.pow(2, this.zoom100);
			var pw = this.panel.width / Math.pow(2, this.zoom100);
			var ph = this.panel.height / Math.pow(2, this.zoom100);
			var minZoom = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_log2___default()(_.min([pw / w / 3, ph / (h + 2 * w)]) / 0.0625) + 1;
			this.map.setMaxBounds([[-(h + 2 * w) / 2, -3 * w / 2], [(h + 2 * w) / 2, 3 * w / 2]]);
			this.map.setMinZoom(minZoom);
		},
		drawPage: function drawPage() {
			var _this4 = this;

			this.clearLayers();
			this.setPageValues();
			var layerOptions = {
				tileSize: this.tileSize,
				noWrap: true,
				sourceUrl: encodeURIComponent(this.view.url),
				page: this.page,
				width: Math.round(this.doc.width.points),
				height: Math.round(this.doc.height.points),
				ratio: this.ratio.toFixed(5),
				overprint: this.showOverprint,
				size: this.tileSize,
				errorTileUrl: __WEBPACK_IMPORTED_MODULE_14__assets_Tile_2x_png___default.a
			};
			var maskUrl = this.rasterMask;
			if (this.selectedInks && this.selectedInks.length < this.inks.length) {
				layerOptions.inks = this.selectedInks.join(",");
				maskUrl = this.separationMask;
			}
			var layer = __WEBPACK_IMPORTED_MODULE_5_leaflet___default.a.tileLayer('' + this.bases.rasterApi + maskUrl, layerOptions).addTo(this.map);
			this.layers.push(layer);

			var redrawTimeout = 4000;
			var tileError = false;

			layer.on('tileerror', function () {
				tileError = true;
			});

			layer.on('load', function () {
				if (!tileError) {
					redrawTimeout = 4000;
				} else {
					setTimeout(function () {
						tileError = false;
						layer.redraw();
					}, redrawTimeout);
					redrawTimeout = Math.min(redrawTimeout * 1.5, 30 * 1000);
				}
				_this4.loading = false;
				_this4.map.fire('dataload');
			});

			this.drawPageBoxes();
			this.drawPageSpine();
			this.calcCentre();
			this.calcOffset();
			this.calcViewport();
			this.setMaxBounds();
		},
		clearLayers: function clearLayers() {
			this.layers.forEach(function (layer) {
				return layer.remove();
			});
			this.boxes = {};
			this.layers = [];
		},
		drawPageBoxes: function drawPageBoxes() {
			var _this5 = this;

			if (!this.view.data.page.boxes) return;
			var selectedBoxes = this.selectedBoxes || [];
			this.view.data.page.boxes = this.view.data.page.boxes.filter(function (box) {
				return !['CropBox', 'ArtBox'].includes(box.type);
			});
			var pixelToLatLng = function pixelToLatLng(p) {
				return p / Math.pow(2, _this5.zoom);
			};
			var pointToLatLng = function pointToLatLng(d) {
				return pixelToLatLng(new __WEBPACK_IMPORTED_MODULE_10__PointMeasure__["a" /* default */](d, 96).toPixel(_this5.zoom));
			};

			var tlx = -this.doc.width.points / 2;
			var tly = this.doc.height.points / 2;

			this.view.data.page.boxes.forEach(function (box) {
				var x = pointToLatLng(tlx + box.left);
				var y = pointToLatLng(tly - box.top);
				var w = pointToLatLng(box.width);
				var h = pointToLatLng(box.height);
				var rect = [[y, x], [y, x + w], [y - h, x + w], [y - h, x], [y, x]];
				var rectangle = __WEBPACK_IMPORTED_MODULE_5_leaflet___default.a.rectangle(rect, {
					color: box.colour,
					weight: 1,
					stroke: selectedBoxes.includes(box.type),
					fill: false
				});
				rectangle.addTo(_this5.map);
				_this5.boxes[box.type] = rectangle;
				_this5.layers.push(rectangle);
			});
		},
		drawPageSpine: function drawPageSpine() {
			var _this6 = this;

			var spines = _.get(this.spineAdjust, 'spines');

			if (!spines) {
				return;
			}

			var pixelToLatLng = function pixelToLatLng(p) {
				return p / Math.pow(2, _this6.zoom);
			};
			var pointToLatLng = function pointToLatLng(d) {
				return pixelToLatLng(new __WEBPACK_IMPORTED_MODULE_10__PointMeasure__["a" /* default */](d, 96).toPixel(_this6.zoom));
			};
			var x = pointToLatLng((this.doc.width.points - this.view.data.page.width) / 2);
			var yStart = pointToLatLng(1.2 * this.doc.height.points / 2);
			var yEnd = pointToLatLng(0.8 * this.doc.height.points / 2 - this.view.data.page.height);
			spines.forEach(function (spine) {
				if (!spine.active) {
					return;
				}

				var coordinates = [[[yStart, x - pointToLatLng(spine.value / 2)], [yEnd, x - pointToLatLng(spine.value / 2)]], [[yStart, x + pointToLatLng(spine.value / 2)], [yEnd, x + pointToLatLng(spine.value / 2)]]];

				var options = { weight: spine.weight, color: spine.colour };

				if (spine.dashArray) {
					options.dashArray = spine.dashArray;
				}

				if (spine.active) {
					var lines = __WEBPACK_IMPORTED_MODULE_5_leaflet___default.a.polyline(coordinates, options).addTo(_this6.map);
					_this6.layers.push(lines);
				}
			});
			this.drawSpineLayers();
		},
		drawSpineLayers: function drawSpineLayers() {
			var _this7 = this;

			var originalSpine = _.find(this.spineAdjust.spines, { type: 'spine.original' });

			if (!originalSpine) {
				return;
			}

			if (!originalSpine.active) {
				return;
			}

			var pixelToLatLng = function pixelToLatLng(p) {
				return p / Math.pow(2, _this7.zoom);
			};
			var pointToLatLng = function pointToLatLng(d) {
				return pixelToLatLng(new __WEBPACK_IMPORTED_MODULE_10__PointMeasure__["a" /* default */](d, 96).toPixel(_this7.zoom));
			};
			var tlx = pointToLatLng((this.doc.width.points - this.view.data.page.width) / 2);
			var x = pointToLatLng(this.doc.width.points / 2);
			var y = pointToLatLng(this.doc.height.points / 2);
			var w = pointToLatLng(this.view.data.page.width);
			var h = pointToLatLng(this.view.data.page.height);
			var leftRect = [[y, x - w], [y - h, tlx - pointToLatLng(originalSpine.value / 2)]];
			var rightRect = [[y, x], [y - h, tlx + pointToLatLng(originalSpine.value / 2)]];
			var fillOptions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ color: '#fff', fillOpacity: 0.6, stroke: false }, _.get(this.spineAdjust, 'layersOptions', {}));
			var lRect = __WEBPACK_IMPORTED_MODULE_5_leaflet___default.a.rectangle(leftRect, fillOptions).addTo(this.map);
			var rRect = __WEBPACK_IMPORTED_MODULE_5_leaflet___default.a.rectangle(rightRect, fillOptions).addTo(this.map);
			this.layers.push(lRect, rRect);
		},
		generateThumbnailUrl: function generateThumbnailUrl() {
			var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.page;

			var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
			    _ref2$size = _ref2.size,
			    size = _ref2$size === undefined ? 100 : _ref2$size;

			if (!this.view || !this.view.url) return;
			return this.bases.rasterApi + '/api/media/thumbnail?page=' + page + '&size=' + size + '&url=' + encodeURIComponent(this.view.url);
		},
		handlePreviewerDragStop: function handlePreviewerDragStop() {
			var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
			    top = _ref3.top,
			    left = _ref3.left;

			var w = this.doc.width.toPixel() / Math.pow(2, this.zoom100);
			var h = this.doc.height.toPixel() / Math.pow(2, this.zoom100);
			var lng = w * (left - 50) / 100;
			var lat = h * (-top + 50) / 100;
			this.map.setView([lat, lng]);
		},
		goToPage: function goToPage() {
			this.loadFile();
		},
		performZoom: function performZoom() {
			this.zoomEnd(this.map.getZoom());
			this.calcCentre();
			this.calcOffset();
			this.calcViewport();
		},
		fitTo: function fitTo(target) {
			var _this8 = this;

			var pixelToLatLng = function pixelToLatLng(p) {
				return p / Math.pow(2, _this8.zoom);
			};
			var pointToLatLng = function pointToLatLng(d) {
				return pixelToLatLng(new __WEBPACK_IMPORTED_MODULE_10__PointMeasure__["a" /* default */](d, 96).toPixel(_this8.zoom));
			};

			var w = pointToLatLng(this.doc.width.points / 2);
			var h = pointToLatLng(this.doc.height.points / 2);
			var docBounds = __WEBPACK_IMPORTED_MODULE_5_leaflet___default.a.latLngBounds(__WEBPACK_IMPORTED_MODULE_5_leaflet___default.a.latLng(-h, -w), __WEBPACK_IMPORTED_MODULE_5_leaflet___default.a.latLng(h, w));

			var bounds = this.boxes['MediaBox'] ? this.boxes['MediaBox'].getBounds() : docBounds;
			var centerY = this.map.getCenter().lat;

			this.map.invalidateSize();
			switch (target) {
				case 'page':
					this.map.fitBounds(bounds);
					break;
				case 'width':
					this.map.fitBounds([[centerY, bounds.getWest()], [centerY, bounds.getEast()]]);
					break;
				default:

			}
		}
	},
	watch: {
		spineAdjust: function spineAdjust() {
			this.drawPage();
		},
		selectedInks: function selectedInks() {
			this.loadFile({ skipMetadata: true });
		},
		showOverprint: function showOverprint() {
			this.loadFile({ skipMetadata: true });
		},
		selectedBoxes: function selectedBoxes(boxNames) {
			_.each(this.boxes, function (box, name) {
				box.setStyle({ stroke: _.includes(boxNames, name) });
			});
		},
		showInks: function showInks() {
			console.log("showInks", this.showInks);
		},
		showBoxes: function showBoxes() {
			var _this9 = this;

			_.each(this.boxes, function (box) {
				return box.setStyle({ stroke: _this9.showBoxes });
			});
		},
		url: function url(_url) {
			this.map.setZoom(this.zoom100);
			this.loadFile();
		},
		zoom: function zoom() {
			if (this.zoom >= 0 && this.zoom <= 12) {
				this.map.setZoom(this.zoom);
				this.performZoom();
			}
		},
		page: function page() {
			this.loadFile();
		}
	}
});

/***/ }),

/***/ 259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PointMeasure__ = __webpack_require__(59);




/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['unit', 'scale', 'orientation', 'zoom', 'length'],
	data: function data() {
		return {
			zoom100: 5,
			textOffset: 3,
			minorTicks: [],
			majorTicks: []
		};
	},

	computed: {
		horizontal: function horizontal() {
			return this.orientation === "horizontal";
		},
		vertical: function vertical() {
			return this.orientation === "vertical";
		},
		svgWidth: function svgWidth() {
			return this.vertical ? "30" : "3000";
		},
		svgHeight: function svgHeight() {
			return this.vertical ? "3000" : "30";
		},
		_scale: function _scale() {
			return parseFloat(this.scale) || 1;
		},
		_dpi: function _dpi() {
			return this.dpi || 96;
		},
		_id: function _id() {
			return this.makeId();
		}
	},
	mounted: function mounted() {
		this.draw();
	},

	methods: {
		makeId: function makeId() {
			var text = "";
			var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
			for (var i = 0; i < 5; i++) {
				text += possible.charAt(Math.floor(Math.random() * possible.length));
			}return text;
		},
		scalePixel: function scalePixel(n) {
			return n * this._scale / Math.pow(2, this.zoom100 - this.zoom);
		},
		tickInch: function tickInch() {
			return this.scalePixel(72);
		},
		tickMm: function tickMm() {
			var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

			return this.scalePixel(n * 2.834645669291339);
		},
		draw: function draw() {
			this.majorTicks = [];
			this.minorTicks = [];

			var unit = '"';
			var multiple = 1;
			var tickPixels = this.tickInch();
			var divisions = 4;

			if (this.unit === "mm") {
				multiple = 10;
				divisions = 2;
				unit = "";
				tickPixels = this.tickMm(multiple);
				if (tickPixels < 20) {
					multiple = 100;
					tickPixels = this.tickMm(100);
					divisions = 10;
				}
			}

			var tickCount = this.scalePixel(this.length) / tickPixels;
			var tickStart = -Math.ceil(tickCount);
			var tickEnd = Math.ceil(tickCount);

			if (this.orientation === "horizontal") {

				for (var i = tickStart; i < tickEnd; i++) {
					var majorTick = {
						x1: i * tickPixels + 2,
						x2: i * tickPixels + 2,
						y1: 10,
						y2: 30,
						value: '' + i * multiple + unit
					};
					this.majorTicks.push(majorTick);
					for (var m = 1; m < divisions; m++) {
						var minorTick = {
							x1: majorTick.x1 + m * (tickPixels / divisions),
							x2: majorTick.x2 + m * (tickPixels / divisions),
							y1: 20,
							y2: 30
						};
						this.minorTicks.push(minorTick);
					}
				}
			} else {

				for (var _i = tickStart; _i < tickEnd; _i++) {
					var _majorTick = {
						y1: _i * tickPixels + 2,
						y2: _i * tickPixels + 2,
						x1: 10,
						x2: 30,
						value: '' + _i * multiple + unit
					};
					this.majorTicks.push(_majorTick);
					for (var _m = 1; _m < divisions; _m++) {
						var _minorTick = {
							y1: _majorTick.y1 + _m * (tickPixels / divisions),
							y2: _majorTick.y2 + _m * (tickPixels / divisions),
							x1: 20,
							x2: 30
						};
						this.minorTicks.push(_minorTick);
					}
				}
			}
		}
	},
	watch: {
		unit: function unit() {
			this.draw();
		},
		scale: function scale() {
			this.draw();
		},
		dpi: function dpi() {
			this.draw();
		},
		zoom: function zoom() {
			this.draw();
		}
	}
});

/***/ }),

/***/ 260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_range__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_debounce__);





/* harmony default export */ __webpack_exports__["default"] = ({
	components: {},
	props: ['url', 'pageCount', 'generateUrl', 'currentPage', 'changePage'],
	watch: {
		url: function url() {
			this.createThumbs();
		},
		pageCount: function pageCount() {
			this.createThumbs();
		},

		currentPage: {
			immediate: true,
			handler: function handler() {
				if (this.currentPage) {
					this.currentThumbsPage = Math.floor(this.currentPage / this.visibleThumbsNumber) + 1;
				}
			}
		}
	},
	created: function created() {
		this.$window = $(window);
		this.$window.on('resize', this.handleWindowResize);
		this.calcVisibleThumbsNumber();
		this.createThumbs();
	},
	destroyed: function destroyed() {
		this.$window.off('resize', this.handleWindowResize);
	},
	data: function data() {
		return {
			thumbnails: [],
			visibleThumbsNumber: 10,
			currentThumbsPage: 1,
			thumbnailUrls: [],
			$window: null
		};
	},

	computed: {
		thumbsRange: function thumbsRange() {
			var start = (this.currentThumbsPage - 1) * this.visibleThumbsNumber + 1;
			var max = Math.abs(this.pageCount - (this.currentThumbsPage - 1) * this.visibleThumbsNumber);
			var end = start + Math.min(this.visibleThumbsNumber, max);

			return __WEBPACK_IMPORTED_MODULE_0_lodash_range___default()(start, end);
		}
	},
	methods: {
		createThumbs: function createThumbs() {
			var _this = this;

			this.thumbnailUrls = new Array(this.pageCount).fill(null).reduce(function (accumulator, unused, index) {
				var page = index + 1;
				accumulator[page] = _this.generateUrl(page);
				return accumulator;
			}, []);
		},
		handleThumbnailClick: function handleThumbnailClick(page) {
			this.changePage(page);
		},
		getThumbnailClass: function getThumbnailClass(thumbnail) {
			return this.currentPage === thumbnail ? 'is-current' : '';
		},
		handlePrevBtnClick: function handlePrevBtnClick() {
			this.currentThumbsPage = Math.max(1, this.currentThumbsPage - 1);
		},
		handleNextBtnClick: function handleNextBtnClick() {
			if (!this.canGoToPage()) return false;
			this.currentThumbsPage = Math.min(this.currentThumbsPage + 1, this.pageCount);
		},
		getPrevBtbClass: function getPrevBtbClass() {
			return this.currentThumbsPage === 1 ? 'is-disabled' : null;
		},
		getNextBtnClass: function getNextBtnClass() {
			return this.canGoToPage(this.currentThumbsPage + 1) ? null : 'is-disabled';
		},
		getThumbnailStyle: function getThumbnailStyle(thumbnail) {
			return 'background-image: url(' + this.thumbnailUrls[thumbnail] + ')';
		},
		canGoToPage: function canGoToPage() {
			var pageNum = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.currentThumbsPage;

			return pageNum * this.visibleThumbsNumber < this.pageCount;
		},
		calcVisibleThumbsNumber: function calcVisibleThumbsNumber() {
			var width = this.$window.width();
			if (width >= 1280) {
				this.visibleThumbsNumber = 10;
			} else if (width >= 992) {
				this.visibleThumbsNumber = 5;
			} else {
				this.visibleThumbsNumber = 3;
			}
		},

		handleWindowResize: __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default()(function () {
			this.calcVisibleThumbsNumber();
		}, 500)
	}
});

/***/ }),

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	props: ["page", "zoomLevel", "zoomIn", "zoomOut", "fitTo", "prevPage", "nextPage", "showInks", "showOverview", "toggleBoxes", "toggleRulers", "setUnits", "showOverprint"],
	data: function data() {
		return {
			pageCount: 0,
			isMobileAdvancedMenuOpen: false
		};
	},

	methods: {
		handleMobileToggleBtnClick: function handleMobileToggleBtnClick() {
			this.isMobileAdvancedMenuOpen = !this.isMobileAdvancedMenuOpen;
		}
	}
});

/***/ }),

/***/ 262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);








/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['show'],
	data: function data() {
		return {
			uploadFiles: []
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['bases'])),
	methods: {
		handleFileChange: function handleFileChange(e) {
			var _this = this;

			var files = e.target.files || e.dataTransfer.files;
			this.uploadFiles = [];
			__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.each(files, function (file) {
				return _this.uploadFiles.push(file);
			});
		},
		handleUploadFile: function handleUploadFile(file) {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				var uploadDataUrl, uploadData, uploadUrl, config, uploadResults;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								console.log(file);
								file.progress = 0;
								uploadDataUrl = _this2.bases.fileApi + '/files/getuploadurl?mimeType=' + file.type;
								_context.next = 5;
								return _this2.$http.get(uploadDataUrl);

							case 5:
								uploadData = _context.sent;
								uploadUrl = uploadData.body.url;
								config = {
									headers: {
										'Content-Type': file.type
									},
									onUploadProgress: function onUploadProgress(progressEvent) {
										file.progress = Math.round(progressEvent.loaded * 100 / progressEvent.total);
										console.log(file.progress);
										_this2.$forceUpdate();
									}
								};
								_context.next = 10;
								return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(uploadData.body.url, file, config);

							case 10:
								uploadResults = _context.sent;

								_this2.$emit("uploadcomplete", {
									file: file,
									uploadUrl: uploadUrl
								});
								_this2.uploadFiles = [];

							case 13:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this2);
			}))();
		},
		formatSizeUnits: function formatSizeUnits(bytes) {
			if (bytes >= 1000000000) {
				bytes = (bytes / 1000000000).toFixed(2) + ' GB';
			} else if (bytes >= 1000000) {
				bytes = (bytes / 1000000).toFixed(2) + ' MB';
			} else if (bytes >= 1000) {
				bytes = (bytes / 1000).toFixed(2) + ' KB';
			} else if (bytes > 1) {
				bytes = bytes + ' bytes';
			} else if (bytes == 1) {
				bytes = bytes + ' byte';
			} else {
				bytes = '0 byte';
			}
			return bytes;
		},
		hideModal: function hideModal() {
			$('.upload-modal').modal('hide');
		},
		showModal: function showModal() {
			$('.upload-modal').modal('show');
		}
	},
	watch: {
		show: function show() {
			this.showModal();
		}
	}
});

/***/ }),

/***/ 310:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 311:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 312:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 313:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 314:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 315:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 316:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 317:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 318:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 319:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 320:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 321:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 403:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 92,
	"./af.js": 92,
	"./ar": 99,
	"./ar-dz": 93,
	"./ar-dz.js": 93,
	"./ar-kw": 94,
	"./ar-kw.js": 94,
	"./ar-ly": 95,
	"./ar-ly.js": 95,
	"./ar-ma": 96,
	"./ar-ma.js": 96,
	"./ar-sa": 97,
	"./ar-sa.js": 97,
	"./ar-tn": 98,
	"./ar-tn.js": 98,
	"./ar.js": 99,
	"./az": 100,
	"./az.js": 100,
	"./be": 101,
	"./be.js": 101,
	"./bg": 102,
	"./bg.js": 102,
	"./bm": 103,
	"./bm.js": 103,
	"./bn": 105,
	"./bn-bd": 104,
	"./bn-bd.js": 104,
	"./bn.js": 105,
	"./bo": 106,
	"./bo.js": 106,
	"./br": 107,
	"./br.js": 107,
	"./bs": 108,
	"./bs.js": 108,
	"./ca": 109,
	"./ca.js": 109,
	"./cs": 110,
	"./cs.js": 110,
	"./cv": 111,
	"./cv.js": 111,
	"./cy": 112,
	"./cy.js": 112,
	"./da": 113,
	"./da.js": 113,
	"./de": 116,
	"./de-at": 114,
	"./de-at.js": 114,
	"./de-ch": 115,
	"./de-ch.js": 115,
	"./de.js": 116,
	"./dv": 117,
	"./dv.js": 117,
	"./el": 118,
	"./el.js": 118,
	"./en-au": 119,
	"./en-au.js": 119,
	"./en-ca": 120,
	"./en-ca.js": 120,
	"./en-gb": 121,
	"./en-gb.js": 121,
	"./en-ie": 122,
	"./en-ie.js": 122,
	"./en-il": 123,
	"./en-il.js": 123,
	"./en-in": 124,
	"./en-in.js": 124,
	"./en-nz": 125,
	"./en-nz.js": 125,
	"./en-sg": 126,
	"./en-sg.js": 126,
	"./eo": 127,
	"./eo.js": 127,
	"./es": 131,
	"./es-do": 128,
	"./es-do.js": 128,
	"./es-mx": 129,
	"./es-mx.js": 129,
	"./es-us": 130,
	"./es-us.js": 130,
	"./es.js": 131,
	"./et": 132,
	"./et.js": 132,
	"./eu": 133,
	"./eu.js": 133,
	"./fa": 134,
	"./fa.js": 134,
	"./fi": 135,
	"./fi.js": 135,
	"./fil": 136,
	"./fil.js": 136,
	"./fo": 137,
	"./fo.js": 137,
	"./fr": 140,
	"./fr-ca": 138,
	"./fr-ca.js": 138,
	"./fr-ch": 139,
	"./fr-ch.js": 139,
	"./fr.js": 140,
	"./fy": 141,
	"./fy.js": 141,
	"./ga": 142,
	"./ga.js": 142,
	"./gd": 143,
	"./gd.js": 143,
	"./gl": 144,
	"./gl.js": 144,
	"./gom-deva": 145,
	"./gom-deva.js": 145,
	"./gom-latn": 146,
	"./gom-latn.js": 146,
	"./gu": 147,
	"./gu.js": 147,
	"./he": 148,
	"./he.js": 148,
	"./hi": 149,
	"./hi.js": 149,
	"./hr": 150,
	"./hr.js": 150,
	"./hu": 151,
	"./hu.js": 151,
	"./hy-am": 152,
	"./hy-am.js": 152,
	"./id": 153,
	"./id.js": 153,
	"./is": 154,
	"./is.js": 154,
	"./it": 156,
	"./it-ch": 155,
	"./it-ch.js": 155,
	"./it.js": 156,
	"./ja": 157,
	"./ja.js": 157,
	"./jv": 158,
	"./jv.js": 158,
	"./ka": 159,
	"./ka.js": 159,
	"./kk": 160,
	"./kk.js": 160,
	"./km": 161,
	"./km.js": 161,
	"./kn": 162,
	"./kn.js": 162,
	"./ko": 163,
	"./ko.js": 163,
	"./ku": 164,
	"./ku.js": 164,
	"./ky": 165,
	"./ky.js": 165,
	"./lb": 166,
	"./lb.js": 166,
	"./lo": 167,
	"./lo.js": 167,
	"./lt": 168,
	"./lt.js": 168,
	"./lv": 169,
	"./lv.js": 169,
	"./me": 170,
	"./me.js": 170,
	"./mi": 171,
	"./mi.js": 171,
	"./mk": 172,
	"./mk.js": 172,
	"./ml": 173,
	"./ml.js": 173,
	"./mn": 174,
	"./mn.js": 174,
	"./mr": 175,
	"./mr.js": 175,
	"./ms": 177,
	"./ms-my": 176,
	"./ms-my.js": 176,
	"./ms.js": 177,
	"./mt": 178,
	"./mt.js": 178,
	"./my": 179,
	"./my.js": 179,
	"./nb": 180,
	"./nb.js": 180,
	"./ne": 181,
	"./ne.js": 181,
	"./nl": 183,
	"./nl-be": 182,
	"./nl-be.js": 182,
	"./nl.js": 183,
	"./nn": 184,
	"./nn.js": 184,
	"./oc-lnc": 185,
	"./oc-lnc.js": 185,
	"./pa-in": 186,
	"./pa-in.js": 186,
	"./pl": 187,
	"./pl.js": 187,
	"./pt": 189,
	"./pt-br": 188,
	"./pt-br.js": 188,
	"./pt.js": 189,
	"./ro": 190,
	"./ro.js": 190,
	"./ru": 191,
	"./ru.js": 191,
	"./sd": 192,
	"./sd.js": 192,
	"./se": 193,
	"./se.js": 193,
	"./si": 194,
	"./si.js": 194,
	"./sk": 195,
	"./sk.js": 195,
	"./sl": 196,
	"./sl.js": 196,
	"./sq": 197,
	"./sq.js": 197,
	"./sr": 199,
	"./sr-cyrl": 198,
	"./sr-cyrl.js": 198,
	"./sr.js": 199,
	"./ss": 200,
	"./ss.js": 200,
	"./sv": 201,
	"./sv.js": 201,
	"./sw": 202,
	"./sw.js": 202,
	"./ta": 203,
	"./ta.js": 203,
	"./te": 204,
	"./te.js": 204,
	"./tet": 205,
	"./tet.js": 205,
	"./tg": 206,
	"./tg.js": 206,
	"./th": 207,
	"./th.js": 207,
	"./tk": 208,
	"./tk.js": 208,
	"./tl-ph": 209,
	"./tl-ph.js": 209,
	"./tlh": 210,
	"./tlh.js": 210,
	"./tr": 211,
	"./tr.js": 211,
	"./tzl": 212,
	"./tzl.js": 212,
	"./tzm": 214,
	"./tzm-latn": 213,
	"./tzm-latn.js": 213,
	"./tzm.js": 214,
	"./ug-cn": 215,
	"./ug-cn.js": 215,
	"./uk": 216,
	"./uk.js": 216,
	"./ur": 217,
	"./ur.js": 217,
	"./uz": 219,
	"./uz-latn": 218,
	"./uz-latn.js": 218,
	"./uz.js": 219,
	"./vi": 220,
	"./vi.js": 220,
	"./x-pseudo": 221,
	"./x-pseudo.js": 221,
	"./yo": 222,
	"./yo.js": 222,
	"./zh-cn": 223,
	"./zh-cn.js": 223,
	"./zh-hk": 224,
	"./zh-hk.js": 224,
	"./zh-mo": 225,
	"./zh-mo.js": 225,
	"./zh-tw": 226,
	"./zh-tw.js": 226
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 403;

/***/ }),

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Tile@2x.b0da9be.png";

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(317)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(253),
  /* template */
  __webpack_require__(424),
  /* scopeId */
  "data-v-8a2e92c4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(319)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(426),
  /* scopeId */
  "data-v-9b19f564",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(312)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(255),
  /* template */
  __webpack_require__(419),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(315)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(256),
  /* template */
  __webpack_require__(422),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(320)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(427),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(321)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(428),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 415:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(311)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(260),
  /* template */
  __webpack_require__(418),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(314)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(261),
  /* template */
  __webpack_require__(421),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(318)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(425),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 418:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ThumbnailsSlider"
  }, [_c('div', {
    staticClass: "ThumbnailsSlider-prev",
    class: _vm.getPrevBtbClass(),
    on: {
      "click": _vm.handlePrevBtnClick
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ThumbnailsSlider-list"
  }, _vm._l((_vm.thumbsRange), function(thumbnail) {
    return _c('div', {
      key: thumbnail,
      staticClass: "ThumbnailItem",
      class: _vm.getThumbnailClass(thumbnail),
      on: {
        "click": function($event) {
          return _vm.changePage(thumbnail)
        }
      }
    }, [_c('div', {
      staticClass: "ThumbnailItem-img"
    }, [_c('div', {
      staticClass: "ThumbnailItem-img-background",
      style: (_vm.getThumbnailStyle(thumbnail))
    })]), _vm._v(" "), _c('div', {
      staticClass: "ThumbnailItem-text"
    }, [_vm._v("\n\t\t\t\t" + _vm._s(thumbnail) + "\n\t\t\t")])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "ThumbnailsSlider-next",
    class: _vm.getNextBtnClass(),
    on: {
      "click": _vm.handleNextBtnClick
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 419:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "frame"
  }, [_c('div', {
    staticClass: "frame-wrapper"
  }, [_c('section', {
    staticClass: "frame-content"
  }, [_c('div', {
    staticClass: "frame-viewer"
  }, [_c('pdf', {
    ref: "pdf",
    attrs: {
      "spineAdjust": _vm.spineAdjust,
      "url": _vm.url,
      "zoom": _vm.zoom,
      "page": _vm.page,
      "unit": _vm.preferences.unit,
      "showOverview": _vm.preferences.showOverview,
      "showOverprint": _vm.preferences.showOverprint,
      "showInks": _vm.preferences.showInks,
      "showRulers": _vm.preferences.showRulers,
      "showBoxes": _vm.preferences.showBoxes,
      "selectedInks": _vm.preferences.selectedInks,
      "selectedBoxes": _vm.preferences.selectedBoxes,
      "changePage": _vm.changePage,
      "onFileLoaded": _vm.handleFileLoaded,
      "zoomEnd": _vm.zoomEnd
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),

/***/ 420:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app",
      "data-version": _vm.version
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 421:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Toolbar"
  }, [_c('div', {
    staticClass: "Toolbar-wrapper"
  }, [_c('div', {
    staticClass: "Toolbar-pageControls"
  }, [_c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.prevPage()
      }
    }
  }, [_c('span', {
    staticClass: "hidden-xs hidden-sm"
  }, [_vm._v("Prev")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.nextPage()
      }
    }
  }, [_c('span', {
    staticClass: "hidden-xs hidden-sm"
  }, [_vm._v("Next")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showInks()
      }
    }
  }, [_vm._v("Inks")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showOverview()
      }
    }
  }, [_vm._v("Overview")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showOverprint()
      }
    }
  }, [_vm._v("Overprint")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleBoxes()
      }
    }
  }, [_vm._v("Boxes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleRulers()
      }
    }
  }, [_vm._v("Rulers")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setUnits('mm')
      }
    }
  }, [_vm._v("mm")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setUnits('inch')
      }
    }
  }, [_vm._v("inch")])])])]), _vm._v(" "), _c('div', {
    staticClass: "Toolbar-zoomControls"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.zoomIn()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zoomLevel),
      expression: "zoomLevel"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "60px"
    },
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.zoomLevel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.zoomLevel = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.zoomOut()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.fitTo('page')
      }
    }
  }, [_vm._v("Fit to page")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.fitTo('width')
      }
    }
  }, [_vm._v("Fit to width")])])]), _vm._v(" "), _c('div', {
    staticClass: "Toolbar-mobileToggle"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleMobileToggleBtnClick
    }
  }, [(!_vm.isMobileAdvancedMenuOpen) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _vm._e(), _vm._v(" "), (_vm.isMobileAdvancedMenuOpen) ? _c('i', {
    staticClass: "fa fa-times"
  }) : _vm._e()])])]), _vm._v(" "), (_vm.isMobileAdvancedMenuOpen) ? _c('div', {
    staticClass: "Toolbar-mobileAdvanced"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showInks()
      }
    }
  }, [_vm._v("Inks")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showOverview()
      }
    }
  }, [_vm._v("Overview")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setUnits('mm')
      }
    }
  }, [_vm._v("mm")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setUnits('inch')
      }
    }
  }, [_vm._v("inch")])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "visible-xs visible-sm"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "visible-xs visible-sm"
  }, [_c('i', {
    staticClass: "fa fa-arrow-right"
  })])
}]}

/***/ }),

/***/ 422:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ink-container"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "control-group"
  }, [_c('ul', {
    staticClass: "ink-list"
  }, [_vm._l((_vm.inks), function(ink) {
    return _c('li', [_c('label', {
      staticClass: "control control--checkbox"
    }, [_vm._v(_vm._s(ink.name) + "\n\t\t\t\t\t\t"), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (ink.selected),
        expression: "ink.selected"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(ink.selected) ? _vm._i(ink.selected, null) > -1 : (ink.selected)
      },
      on: {
        "change": function($event) {
          var $$a = ink.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(ink, "selected", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(ink, "selected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(ink, "selected", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "control__indicator"
    })])])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs pull-right",
    staticStyle: {
      "margin-top": "20px"
    },
    on: {
      "click": function($event) {
        return _vm.reload()
      }
    }
  }, [_vm._v("Reload")])], 2)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 423:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pdf"
  }, [_c('div', {
    attrs: {
      "id": "inch1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pdf-container"
  }, [_c('div', {
    staticClass: "pdf-viewer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRulers),
      expression: "showRulers"
    }],
    staticClass: "vertical-ruler"
  }, [_c('ruler', {
    style: ([_vm.offset.base, _vm.offset.v]),
    attrs: {
      "unit": _vm.unit,
      "length": _vm.doc.height.toPixel(),
      "scale": _vm.ratio,
      "zoom": _vm.zoom,
      "orientation": "vertical"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRulers),
      expression: "showRulers"
    }],
    staticClass: "horizontal-ruler"
  }, [_c('ruler', {
    style: ([_vm.offset.base, _vm.offset.h]),
    attrs: {
      "unit": _vm.unit,
      "length": _vm.doc.width.toPixel(),
      "scale": _vm.ratio,
      "zoom": _vm.zoom,
      "orientation": "horizontal"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "viewer"
    }
  }), _vm._v(" "), (_vm.view && _vm.view.url) ? _c('div', {
    staticClass: "pdf-viewer-overviewMap"
  }, [_c('OverviewMap', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showOverview),
      expression: "showOverview"
    }],
    attrs: {
      "view": _vm.view,
      "generateUrl": _vm.generateThumbnailUrl,
      "onDragStop": _vm.handlePreviewerDragStop,
      "viewport": _vm.viewport
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pdf-bottom"
  }, [(_vm.url) ? _c('ThumbnailsSlider', {
    attrs: {
      "url": _vm.url,
      "pageCount": _vm.doc.pageCount,
      "generateUrl": _vm.generateThumbnailUrl,
      "currentPage": _vm.page,
      "changePage": _vm.changePage
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 424:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Browse"
  }, [_c('div', {
    staticClass: "Browse-wrapper"
  }, [_c('section', {
    staticClass: "Browse-content"
  }, [_c('div', {
    staticClass: "Browse-viewer"
  }, [_c('toolbar', {
    attrs: {
      "page": _vm.page,
      "zoomLevel": _vm.zoomLevel,
      "zoomIn": _vm.zoomIn,
      "zoomOut": _vm.zoomOut,
      "fitTo": _vm.fitTo,
      "prevPage": _vm.prevPage,
      "nextPage": _vm.nextPage,
      "showInks": _vm._showInks,
      "showOverview": _vm._showOverview,
      "showOverprint": _vm._showOverprint,
      "toggleBoxes": _vm._toggleBoxes,
      "toggleRulers": _vm._toggleRulers,
      "set-units": _vm.setUnits
    }
  }), _vm._v(" "), _c('pdf', {
    ref: "pdf",
    attrs: {
      "url": _vm.url,
      "zoom": _vm.zoom,
      "page": _vm.page,
      "unit": _vm.unit,
      "showOverview": _vm.showOverview,
      "showInks": _vm.showInks,
      "showBoxes": _vm.showBoxes,
      "showRulers": _vm.showRulers,
      "changePage": _vm.changePage,
      "zoomEnd": _vm.zoomEnd,
      "showOverprint": _vm.showOverprint
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade folder-modal",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "id": "folder-modal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newFolderName),
      expression: "newFolderName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newFolderName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newFolderName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.handleCloseFolderModal()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.newFolderName
    },
    on: {
      "click": function($event) {
        return _vm.createFolder()
      }
    }
  }, [_vm._v("Create\n\t\t\t\t\t\t\tFolder\n\t\t\t\t\t\t")])])])])]), _vm._v(" "), _c('upload', {
    attrs: {
      "show": _vm.showModal
    },
    on: {
      "uploadcomplete": _vm.uploadComplete
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Upload Files")])])
}]}

/***/ }),

/***/ 425:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade upload-modal",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "id": "upload-modal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', [_c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.handleFileChange
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table file-table"
  }, [_c('tbody', _vm._l((_vm.uploadFiles), function(file) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(file.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatSizeUnits(file.size)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(file.progress) + "%")]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-xs btn-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.handleUploadFile(file)
        }
      }
    }, [_vm._v("Upload")])])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModal()
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary hide",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.uploadItem(_vm.file)
      }
    }
  }, [_vm._v("Upload")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Upload Files")])])
}]}

/***/ }),

/***/ 426:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "file-list"
  }, [_c('table', {
    staticClass: "table file-list"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.folders), function(folder) {
    return _c('tr', {
      staticClass: "frow",
      on: {
        "click": function($event) {
          return _vm.goToFolder($event, folder)
        }
      }
    }, [_vm._m(1, true), _vm._v(" "), _c('td', {
      staticClass: "name"
    }, [_vm._v(_vm._s(folder.name))]), _vm._v(" "), _c('td')])
  }), _vm._v(" "), _vm._l((_vm.files), function(file) {
    return _c('tr', {
      staticClass: "frow file-row",
      on: {
        "click": function($event) {
          return _vm.handleMetadataClick(file)
        }
      }
    }, [_vm._m(2, true), _vm._v(" "), _c('td', {
      staticClass: "name"
    }, [_vm._v(_vm._s(file.name))]), _vm._v(" "), _c('td')])
  })], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "icon-col"
  }, [_vm._v("Name")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "icon fa fa-folder-o fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "icon fa fa-file-o fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),

/***/ 427:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "OverviewMap"
  }, [_c('img', {
    staticClass: "OverviewMap-img",
    attrs: {
      "src": _vm.imgUrl,
      "draggable": "false"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "OverviewMap-currentViewport",
    style: (_vm.currentViewportStyle())
  })])
},staticRenderFns: []}

/***/ }),

/***/ 428:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "id": _vm._id,
      "width": _vm.svgWidth,
      "height": _vm.svgHeight
    }
  }, [_vm._l((_vm.minorTicks), function(tick) {
    return _c('line', {
      attrs: {
        "x1": tick.x1,
        "x2": tick.x2,
        "y1": tick.y1,
        "y2": tick.y2,
        "stroke": "#777",
        "stroke-width": "1"
      }
    })
  }), _vm._v(" "), _vm._l((_vm.majorTicks), function(tick) {
    return _c('line', {
      attrs: {
        "x1": tick.x1,
        "x2": tick.x2,
        "y1": tick.y1,
        "y2": tick.y2,
        "stroke": "#777",
        "stroke-width": "1"
      }
    })
  }), _vm._v(" "), _vm._l((_vm.majorTicks), function(tick) {
    return (_vm.horizontal) ? _c('text', {
      attrs: {
        "x": tick.x1 + _vm.textOffset,
        "y": "15",
        "fill": "black",
        "font-size": "10"
      }
    }, [_vm._v(_vm._s(tick.value))]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.majorTicks), function(tick) {
    return (_vm.vertical) ? _c('text', {
      attrs: {
        "y": tick.y1 + 12,
        "x": "5",
        "fill": "black",
        "font-size": "10"
      }
    }, [_vm._v(_vm._s(tick.value))]) : _vm._e()
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 431:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 59:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var PointMeasure = function () {
	function PointMeasure(points, dpi) {
		__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PointMeasure);

		this.points = points;
		this.dpi = dpi;
	}

	__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(PointMeasure, [{
		key: "toInch",
		value: function toInch() {
			return this.points / 72;
		}
	}, {
		key: "toMM",
		value: function toMM() {
			return this.points / (72 * 25.4);
		}
	}, {
		key: "toPixel",
		value: function toPixel(zoom) {
			return this.dpi * this.points / 72 / Math.pow(2, 5 - zoom || 0);
		}
	}]);

	return PointMeasure;
}();

/* harmony default export */ __webpack_exports__["a"] = (PointMeasure);

/***/ })

},[251]);


// WEBPACK FOOTER //
// static/js/app.0ba22dac055cc5739d22.js